export const PLCC_BANNER_EMPTY_DIV_HEIGHT = 50;
export const PLCC_BANNER_PRICE_THRESHHOLD = 100;
export const PLCC_BANNER_ALL_OTHER_THRESHHOLD_MSG =
    '<b>35% off</b><sup>*</sup> select purchases when you open and use a new JCPenney Credit Card.&nbsp;';
export const PLCC_BANNER_FOR_SPECIAL_FINANCING =
    '<b>Special financing</b> available with your JCPenney Credit Card.&nbsp;';
export const PLCC_MSG_TIER1 =
    'Get <b>$35 off*</b> Your first purchase of $35 or more or $125 off* your first purchase over $500 when you open and use a new JCPenney Credit Card.';
export const PLCC_MSG_TIER2 =
    'Get <b>$125 off*</b> your first purchase over $500 when you open and use a new JCPenney credit card, plus <b>special financing</b> available.';
export const PLCC_BANNER_CATID_INCLUSION_LIST = [
    {
        threshhold: 500,
        catIds: [
            'cat100260213',
            'cat100260226',
            'cat100260228',
            'cat100260229',
            'cat100260230',
            'cat100260231',
            'cat100260235',
            'cat11200000138',
            'cat11200000143',
            'cat11100008503',
            'cat1007440003',
            'cat1003110004',
        ],
        content:
            '<b>20% off</b><sup>*</sup> select blinds & shades when you open and use a new JCPenney Credit Card, plus <b>special financing</b> available.&nbsp;',
        updatedcontent:
            '<b>20% off</b><sup>*</sup> select blinds & shades when you open and use a new JCPenney Credit Card.&nbsp;',
    },
    {
        threshhold: 499,
        catIds: [
            'cat100240019',
            'cat100240095',
            'cat100240127',
            'cat100240133',
            'cat1002460008',
            'cat1002460009',
            'cat1002470003',
            'cat100330047',
            'cat100250035',
            'cat100250036',
            'cat1006240005',
            'cat100250054',
            'cat100250055',
            'cat100250056',
            'cat100240134',
            'cat100250034',
            'cat100250026',
            'cat1003160039',
            'cat100250025',
            'cat1002460007',
            'cat100300116',
            'cat1009750002',
            'cat100250057',
            'cat100250024',
            'cat1001290032',
        ],
        content:
            '<b>20% off</b><sup>*</sup> select furniture when you open and use a new JCPenney Credit Card, plus <b>special financing</b> available.&nbsp;',
        updatedcontent:
            '<b>20% off</b><sup>*</sup> select furniture when you open and use a new JCPenney Credit Card.&nbsp;',
    },
    {
        threshhold: 499,
        catIds: [
            'cat1009550014',
            'cat1009550004',
            'cat1009550005',
            'cat1009550007',
            'cat1009550006',
            'cat100240132',
        ],
        content:
            '<b>20% off</b><sup>*</sup> select mattresses when you open and use a new JCPenney Credit Card, plus <b>special financing</b> available.&nbsp;',
        updatedcontent:
            '<b>20% off</b><sup>*</sup> select mattresses when you open and use a new JCPenney Credit Card.&nbsp;',
    },
    {
        threshhold: 300,
        catIds: [
            'cat10010020003',
            'cat100240086',
            'cat100240093',
            'cat100240094',
            'cat100240096',
            'cat100250007',
            'cat100260183',
            'cat100260184',
            'cat100260186',
            'cat100260187',
            'cat100260192',
            'cat100260194',
            'cat1003050007',
            'cat1003050008',
            'cat1004860021',
            'cat100510003',
            'cat1009750001',
            'cat11100003643',
            'cat11100003719',
            'cat11100007834',
            'cat11100007835',
            'cat11100007888',
            'cat11100008053',
            'cat11100016642',
            'cat100240091',
            'cat100260188',
            'cat100260189',
            'cat100260190',
            'cat100260191',
            'cat1002700041',
            'cat11100003648',
            'cat1009610001',
            'cat1009610002',
            'cat1009610003',
            'cat1009610004',
            'cat1005850002',
            'cat1009920002',
            'cat1005820003',
            'cat1110000434',
            'cat1005820004',
            'cat11100008055',
            'cat11100004292',
            'cat11100008054',
            'cat11100004291',
            'cat1005820009',
            'cat10010990003',
            'cat11100015075',
            'cat11100021259',
            'cat11100016642',
            'cat11100021258',
        ],
        content:
            '<b>35% off</b><sup>*</sup> select jewelry when you open and use a new JCPenney Credit Card, plus <b>special financing</b> available.&nbsp;',
        updatedcontent:
            '<b>35% off</b><sup>*</sup> select jewelry when you open and use a new JCPenney Credit Card.&nbsp;',
    },
    {
        threshhold: 300,
        catIds: [
            'cat1002300028',
            'cat1002300029',
            'cat1002300030',
            'cat100240089',
            'cat1003480102',
            'cat1005800005​',
        ],
        content:
            '<b>20% off</b><sup>*</sup> select watches when you open and use a new JCPenney Credit Card, plus <b>special financing</b> available.&nbsp;',
        updatedcontent:
            '<b>20% off</b><sup>*</sup> select watches when you open and use a new JCPenney Credit Card.&nbsp;',
    },
];

export default {
    PLCC_BANNER_CATID_INCLUSION_LIST,
};
